export default "__VITE_ASSET__e2f547d4__"